export const BRAND_USER_BASE_URL = '/brand';
export const SHOP_USER_BASE_URL = '';
